import React, { createContext, useContext, useEffect, useState } from 'react';
import { backendGet } from '../lib/backendClient';

const ThemeContext = createContext({ theme: null });

const DEFAULT_THEME = {
  theme_name: 'correfood',
  palette: {
    primary: '#FF6A00',
    background: '#0B0B0F',
    surface: '#12121A',
    text: '#FFFFFF',
    muted: '#B8B8C5',
    page_bg: '#f8f9fa',
    card_bg: '#ffffff',
    footer_bg: '#202124',
    button_bg: '#FF6B00',
    button_text: '#ffffff',
    header_bg: '#ffffff'
  }
};

function applyTheme(theme) {
  if (!theme || !theme.palette) return;
  const root = document.documentElement;
  Object.entries(theme.palette).forEach(([key, value]) => {
    root.style.setProperty(`--theme-${key}`, value);
  });

  if (theme.palette.primary) {
    root.style.setProperty('--primary-orange', theme.palette.primary);
  }
  if (theme.palette.background) {
    root.style.setProperty('--black', theme.palette.background);
  }
  if (theme.palette.text) {
    root.style.setProperty('--white', theme.palette.text);
  }
  if (theme.palette.page_bg) {
    root.style.setProperty('--page-bg', theme.palette.page_bg);
  }
  if (theme.palette.card_bg) {
    root.style.setProperty('--card-bg', theme.palette.card_bg);
  }
  if (theme.palette.footer_bg) {
    root.style.setProperty('--footer-bg', theme.palette.footer_bg);
  }
  if (theme.palette.button_bg) {
    root.style.setProperty('--button-bg', theme.palette.button_bg);
  }
  if (theme.palette.button_text) {
    root.style.setProperty('--button-text', theme.palette.button_text);
  }
  if (theme.palette.header_bg) {
    root.style.setProperty('--header-bg', theme.palette.header_bg);
  }
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(DEFAULT_THEME);

  useEffect(() => {
    let mounted = true;

    const loadTheme = async () => {
      try {
        const data = await backendGet('/api/v2/admin/public/theme', { skipAuth: true });
        if (data && mounted) {
          const merged = {
            ...DEFAULT_THEME,
            ...data,
            palette: { ...DEFAULT_THEME.palette, ...(data.palette || {}) }
          };
          setTheme(merged);
          applyTheme(merged);
        }
      } catch {
        applyTheme(DEFAULT_THEME);
      }
    };

    loadTheme();

    return () => {
      mounted = false;
    };
  }, []);

  return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  return useContext(ThemeContext);
}
